export function dealImporterPageLoader(_queryClient) {
  return function (opts) {
    const url = new URL(opts.request.url);
    const pipeline = url.searchParams.get('pipeline');
    const stage = url.searchParams.get('stage');
    const search = url.searchParams.get('search');
    const page = url.searchParams.get('page') || '0';

    return { stage, search, page: parseInt(page), pipeline };
  };
}
